// Shared expiry-date helpers. `expiry_date` is stored as a calendar date with
// no timezone, so "today" must be computed in the user's local clock —
// otherwise users east of UTC would flip a batch to "expired" up to a day
// early. ISO-8601 dates (YYYY-MM-DD) compare correctly with string `<`.

export type ExpiryStatus = 'expired' | 'expiring_soon' | 'healthy' | 'no_expiry';

/** Default window used by the Stock Status screen for the row-level "expiring
 *  soon" indicator. The Adjust screen uses 30 for its narrower affordance. */
export const DEFAULT_EXPIRING_WITHIN_DAYS = 60;

function localTodayIso(): string {
  const now = new Date();
  return (
    now.getFullYear().toString().padStart(4, '0') +
    '-' +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    now.getDate().toString().padStart(2, '0')
  );
}

function localIsoPlusDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return (
    d.getFullYear().toString().padStart(4, '0') +
    '-' +
    (d.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    d.getDate().toString().padStart(2, '0')
  );
}

export function isPastDate(yyyyMmDd: string | null | undefined): boolean {
  if (!yyyyMmDd) return false;
  return yyyyMmDd < localTodayIso();
}

export function expiryStatus(
  yyyyMmDd: string | null | undefined,
  withinDays: number = DEFAULT_EXPIRING_WITHIN_DAYS,
): ExpiryStatus {
  if (!yyyyMmDd) return 'no_expiry';
  const today = localTodayIso();
  if (yyyyMmDd < today) return 'expired';
  if (yyyyMmDd <= localIsoPlusDays(withinDays)) return 'expiring_soon';
  return 'healthy';
}
